module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_Uhr_Layer.00a7ec7f.svg";